






































import { defineComponent } from 'vue-demi';
import { useVuex } from 'common-module/src/util/useVuex';
import theme from '@zk/theme/lib/variables.scss';
import { locationRefresh } from '@/utils';
export default defineComponent({
  name: 'PushPopover',
  bemNS: theme.bemNS,
  components: {},
  props: {
    value: {
      type: Boolean,
      default: false
    },
    width: {
      type: [Number, String],
      default: 296
    },
    placementPosition: {
      type: String,
      default: 'right'
    },
    isOverseasRight: {
      type: Boolean,
      default: false
    }
  },
  inject: ['appLayout'],
  setup(props, { emit }) {
    const handleClose = () => {
      const store = useVuex();
      emit('resetPosition');

      store.commit('app/UPDATE_VERSION_UPDATE_INFO', { show: false });
    };
    const handleReload = () => {
      // window.location.reload();
      locationRefresh();
    };
    return {
      handleClose,
      handleReload
    };
  }
});
